import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"
import "chartjs-adapter-date-fns"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object }

  connect() {
    const config = {
      views: { borderColor: "rgb(59, 130, 246)", label: "Views", yAxisID: "y" },
      reactions: { borderColor: "rgb(249, 115, 22)", label: "Reactions", yAxisID: "y2" },
      comments: { borderColor: "rgb(16, 185, 129)", label: "Comments", yAxisID: "y2" },
      reposts: { borderColor: "rgb(156, 163, 175)", label: "Reposts", yAxisID: "y2" }
    }

    const datasets = Object.entries(this.dataValue).map(([key, points]) => ({
      label: config[key].label,
      data: points.map(p => ({ x: p.x + "T00:00:00Z", y: p.y })),
      borderColor: config[key].borderColor,
      backgroundColor: config[key].borderColor,
      yAxisID: config[key].yAxisID,
      fill: false,
      tension: 0.3,
      pointRadius: 3,
      pointHoverRadius: 5,
      borderWidth: 2
    }))

    new Chart(this.canvasTarget, {
      type: "line",
      data: { datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        scales: {
          x: {
            type: "time",
            time: { unit: "day", tooltipFormat: "MMM d" },
            title: { display: false }
          },
          y: {
            position: "left",
            title: { display: true, text: "Views" },
            beginAtZero: true
          },
          y2: {
            position: "right",
            title: { display: true, text: "Engagement" },
            beginAtZero: true,
            grid: { display: false }
          }
        }
      }
    })
  }
}
